<template>
  <rv-step-sidebar-content
    data-automation="step-mail-invitation__content"
    :title="isCreating
      ? $t('members.titles.memberCreated')
      : $t('members.titles.passwordReset')"
  >
    <div class="step-mail-invitation">
      <div class="flex justify-center q-mx-lg q-mb-lg">
        <q-icon
          class="step-mail-invitation__icon flex justify-center q-mb-sm"
          data-automation="step-mail-invitation__icon"
          name="img:/rvai-base/mail-invitation-luigi.svg"
          size="7rem"
        />

        <div data-automation="step-mail-invitation__label">
          {{ isCreating ? $t('members.titles.invitation') : $t('members.titles.invitationReset') }}
        </div>
      </div>
      <div class="flex column q-mt-md q-mx-lg">
        <rv-button
          class="q-mb-sm"
          data-automation="step-mail-invitation__invite"
          :href="invitationMailto"
          :label="isCreating ? $t('members.titles.mailInvitationLink') : $t('members.titles.mailResetPasswordLink')"
          target="_blank"
          type="a"
        />
        <rv-copy-content-btn
          data-automation="step-mail-invitation__invite-copy"
          :flat="false"
          :label="isCreating ? $t('general.actions.copyLink') : $t('members.titles.copyResetPasswordLink') "
          no-icon
          secondary
          show-default-label
          :value="isCreating ? member.invitationLink : member.resetPasswordLink"
        />
      </div>
    </div>
  </rv-step-sidebar-content>
</template>

<script lang="ts" setup>
import {
  computed,
  type PropType,
} from 'vue'
import { useI18n } from 'vue-i18n'
import type { Member } from '~domain/Member'


const props = defineProps({
  isCreating: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  member: {
    required: true,
    type: Object as PropType<Member>,
  },
})

const { t } = useI18n()

const invitationMailto = computed(() => {
  // We have to encode the body and subject to encode special characters
  // such as , / ? & which are not encoded in a URI by default.
  // However, we should avoid double encoding of "normal" encoded characters
  // such as spaces, therefore decodeURI(encodeURIComponent(...))
  const body = decodeURI(encodeURIComponent(t(props.isCreating ? 'members.mail.creteUserbody' : 'members.mail.resetPasswordBody', {
    email: props.member.email,
    link: props.isCreating ? props.member.invitationLink : props.member.resetPasswordLink,
  })))
  const subject = decodeURI(encodeURIComponent(props.isCreating ? t('members.mail.creteUserSubject') : t('members.mail.resetPasswordSubject')))
  return `mailto:${props.member.email}?subject=${subject}&body=${body}`
})
</script>

<style lang="sass" scoped>
.step-mail-invitation
  &__icon
    margin-top: 64px
    margin-bottom: 40px
</style>
